import React from 'react';
import {Button} from 'react-bootstrap';
import FormOverlay from '../../../../components/FormOverlay';

const ConfirmForm = (props) => {
    return (
        <FormOverlay onFormHide={props.onFormHide}>
            <div className={'form-overlay-body'} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'auto', width: 'auto', padding: '2rem'}}>
                <p>Are u sure u wanna remove bid <strong>{props.country}</strong>?</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button bsStyle={'info'} onClick={props.onFormHide}>No</Button>
                    <Button bsStyle={'danger'} onClick={props.onConfirm}>Yes</Button>
                </div>
            </div>
        </FormOverlay>
    );
}

export default ConfirmForm;



// WEBPACK FOOTER //
// ./src/scenes/AdkBids/components/ConfirmForm/index.js